<div class="message-container text-center">
    <div class="header">Access Denied</div>
    <div>Sorry, you are not authorized to view this page.</div>
    <div class="button-container"><app-button text="TAKE ME HOME" (onClick)="gotoDashboard()"></app-button></div>
  </div>